import * as React from "react";
import type { SVGProps } from "react";
const SvgTagWithEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.97 16.54h.44l-.06-.07a3.28 3.28 0 0 0 3.38-3.25 1 1 0 1 0-2 0 1.42 1.42 0 0 1-.37.94 1.55 1.55 0 0 1-.801.361l.131-.131a1 1 0 0 0-1.37-1.442 1.015 1.015 0 0 0-1.47-1.398l-.203.203c.015-.366.136-.696.373-.933a1.38 1.38 0 0 1 .94-.37 1 1 0 0 0 0-2 3.35 3.35 0 0 0-2.29 1c-1 1-1.204 2.534-.667 3.947l-.053.053a1 1 0 0 0 .71 1.71 1 1 0 0 0 .424-.077l.092.094a1 1 0 0 0 .529 1.334c.122.052.253.078.385.079a1 1 0 0 0 .7-.3l.038-.038q.55.213 1.142.288"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.48 21.77a3 3 0 0 0 1.16.23 3 3 0 0 0 2.14-.89l4.83-4.83a3 3 0 0 0 0-4.28L12.5 3.88A3 3 0 0 0 10.36 3H6.5a4 4 0 0 0-4 4v3.86A3 3 0 0 0 3.39 13l8.11 8.11c.28.283.613.507.98.66M5.087 5.586A2 2 0 0 1 6.5 5h3.86a1 1 0 0 1 .72.3l8.12 8.12a1 1 0 0 1 0 1.45l-4.83 4.83a1 1 0 0 1-1.45 0L4.8 11.58a1 1 0 0 1-.3-.72V7a2 2 0 0 1 .586-1.414"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTagWithEuro;
